// Checks every Range of motion pair under an element again (goals_v3_range_pair_controller). A pair
// checks itself as its boxes are typed in; auto-save's restore writes the boxes without typing them
// (helpers/form-region), so the sections it restores ask their pairs to check what it wrote.
//
// application  the Stimulus application the pairs' controllers run in
// scope        the element whose pairs are checked
export default function recheckRangePairs(application, scope) {
  scope.querySelectorAll('[data-controller~="goals-v3-range-pair"]').forEach((element) => {
    const pair = application.getControllerForElementAndIdentifier(element, 'goals-v3-range-pair');
    if (pair) pair.check();
  });
}
